import { useState } from 'react';
import ImageMagnifier from './ImageMagnifier';

const DragDropImageUpload = ({ 
    onImageUpload, 
    imagePreview, 
    onImageRemove,
    minSize = 220,
    placeholder = "Image preview will appear here",
    errorMessage = null
}) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.type.startsWith('image/')) {
                onImageUpload(file);
            } else {
                onImageUpload(null, 'Please upload a valid image file.');
            }
        }
    };

    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        onImageUpload(file);
    };

    const handleRemoveImage = (e) => {
        e.stopPropagation();
        if (onImageRemove) {
            onImageRemove();
        }
    };

    return (
        <div className="image-upload-container">
            <div 
                className={`image-upload-dropzone ${isDragging ? 'dragging' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById('imageUpload').click()}
                style={{
                    border: `2px dashed ${isDragging ? '#d97706' : '#ccc'}`,
                    borderRadius: '12px',
                    padding: '40px 20px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    backgroundColor: isDragging ? '#fef3c7' : '#f9fafb',
                    transition: 'all 0.3s ease',
                    minHeight: '300px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative'
                }}
            >
                <input
                    type="file"
                    id="imageUpload"
                    name="imageUpload"
                    accept="image/*"
                    onChange={handleFileInputChange}
                    style={{ display: 'none' }}
                />
                
                {imagePreview ? (
                    <div style={{ 
                        position: 'relative', 
                        width: '100%', 
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '300px'
                    }}>
                        <ImageMagnifier
                            src={imagePreview}
                            alt="Uploaded Preview"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '250px',
                                objectFit: 'contain',
                                borderRadius: '8px'
                            }}
                            magnificationLevel={10}
                            magnifierSize={600}
                            indicatorText="Hover to zoom"
                            indicatorPosition="bottom-right"
                        />
                        
                        <button
                            type="button"
                            onClick={handleRemoveImage}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#ef4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '30px',
                                height: '30px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                            }}
                            title="Remove image"
                        >
                            ×
                        </button>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ 
                            fontSize: '48px', 
                            color: isDragging ? '#d97706' : '#9ca3af',
                            marginBottom: '16px'
                        }}>
                            📷
                        </div>
                        <p style={{ 
                            fontSize: '18px', 
                            color: isDragging ? '#d97706' : '#6b7280',
                            margin: '0 0 8px 0',
                            fontWeight: '500'
                        }}>
                            {isDragging ? 'Drop image here' : placeholder}
                        </p>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#9ca3af',
                            margin: '0'
                        }}>
                            Drag & drop an image or click to browse
                        </p>
                        <p style={{ 
                            fontSize: '12px', 
                            color: '#9ca3af',
                            margin: '8px 0 0 0'
                        }}>
                            Minimum size: {minSize}px × {minSize}px
                        </p>
                    </div>
                )}
            </div>
            
            {errorMessage && (
                <div style={{
                    color: '#ef4444',
                    fontSize: '14px',
                    marginTop: '8px',
                    textAlign: 'center'
                }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default DragDropImageUpload;